import "../../assets/style/race.css";
import { useEffect, useMemo, useState } from "react";
import GrandPrixSessionTitle from "../../components/GrandPrix/GrandPrixSessionTitle";
import ErrorPage from "../../views/ErrorPage";
import axios from "axios";
import { useTranslation } from "react-i18next";
import ResultsHeader from "../../views/grand-prix/ResultsHeader";
import RaceRow from "../../views/grand-prix/race/RaceRow";
import LoadingContent from "../../components/LoadingContent";
import useSeasonStyles from "../../hooks/useSeasonStyles";
import { ClassFilter, getClassArray, getClassArraySimple } from "./ClassFilter";
import CircuitLayout from "../CircuitLayout";
import GrandPrixPosition from "./GrandPrixPosition";
import GrandPrixDriver from "./GrandPrixDriver";
import GrandPrixTeam from "./GrandPrixTeam";
import GrandPrixSectors from "./GrandPrixSectors";
import SuperRally from "./SuperRally";

const GrandPrixStages = ({ grand_prix_name }: { grand_prix_name: string }) => {
  const { t } = useTranslation();
  const [activeDriver, setActiveDriver] = useState({});
  const [loading, setLoading] = useState(true);
  const [typeRaces, setTypeRaces] = useState();
  const [isSR, setIsSR] = useState(false);
  const [hasTeams, setHasTeams] = useState();
  const [classFilter, setClassFilter] = useState<string | null>(null);
  const [gpNameUpd, setGpNameUpd] = useState("");
  const [rally, setRally] = useState<any>();
  const [legs, setLegs] = useState(0);
  const [stage, setStage] = useState(0);
  const style = useSeasonStyles(`${grand_prix_name}`);
  const [race, setRace] = useState<{
    [key: string]: string | number;
  }>({});

  useEffect(() => {
    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/grandprix/getRace`,
        {
          params: {
            name: grand_prix_name,
            stage: stage,
          },
        }
      )
      .then(({ data }) => {
        setRace(data.raceResults);
        setTypeRaces(data.type_races);
        setHasTeams(data.has_teams);
        setRally(data.rally);
        setLegs(data.rally[data.rally.length - 1].leg);
        setLoading(false);
        setGpNameUpd(grand_prix_name);
        setIsSR(data.isSR);
      })
      .catch(({ response }) => {
        setLoading(false);
        throw new Error(response);
      });
  }, [grand_prix_name, stage]);

  if (loading) return <LoadingContent />;
  else if (
    grand_prix_name == null ||
    Object.keys(race).length === 0 ||
    gpNameUpd == ""
  )
    return <ErrorPage />; //just in case gp name does not exist
  return (
    <>
      <div className="stages-container">
        {rally.map((circuit: any, index: number) => {
          return (
            <div onClick={() => setStage(index)}>
              <label>{circuit.name}</label>
              <div>
                <CircuitLayout
                  circuit_id={circuit.id}
                  id_canvas={`circuit-${circuit.id}`}
                  strokeWidth={3}
                />
              </div>
            </div>
          );
        })}
      </div>
      {Object.entries(race).map((item, index) => {
        let session = item[0];
        const results: any = item[1];
        let testDriver: any = null;
        let testLap: any = null;
        let classArray = getClassArray(results);
        try {
          testDriver = results[0][0];
          testLap = results[0][0].laps[0];
        } catch (e) {}
        return (
          <div key={index} className={`session rq-session ${style}`}>
            <div className="session-content">
              <div className="session-title text-center">
                <label>{rally[stage].name.toUpperCase()}</label>
                {classArray.length > 1 && (
                  <ClassFilter
                    classes={classArray}
                    classFilter={classFilter}
                    setClassFilter={setClassFilter}
                    race={race}
                    setRace={setRace}
                    grand_prix_name={gpNameUpd}
                  />
                )}
              </div>
              <ResultsHeader
                testDriver={testDriver}
                page="Rally"
                typeRaces={1}
                hasTeams={1}
                laps={undefined}
                legs={legs}
                isSR={isSR}
                stages={true}
                showSectors={true}
              />
              <div className="session-drivers">
                {results.map((driver_: any, index: number) => {
                  const driver = driver_[0];
                  if (classFilter != null && driver.class != classFilter)
                    return <></>;
                  return (
                    <div key={index} className="gp-driver-laps-container">
                      <div
                        className={`gp-driver-row flex ${
                          driver.team === "LigaVirtualF1 Team"
                            ? "lvf1-driver"
                            : ""
                        }`}
                      >
                        <GrandPrixPosition driver={driver} session={session} />
                        <GrandPrixDriver driver={driver} />
                        <GrandPrixTeam driver={driver} />
                        {driver.class !== null &&
                          driver.class_color != null && (
                            <div className="gp-sector text-center">
                              <label
                                className="class_content"
                                style={{ background: driver.class_color }}
                              >
                                {driver.class.toUpperCase()}
                              </label>
                            </div>
                          )}
                        <div className="gp-gap text-center">
                          <label>
                            {driver.gapGral != null && classFilter == null
                              ? driver.gapGral
                              : driver.gap}
                          </label>
                        </div>
                        <div className="gp-hotlap text-center">
                          <label>
                            {driver.laps != null && driver.laps[0].time}
                            {driver.laps != null && (
                              <SuperRally lap={driver.laps[0]} />
                            )}
                          </label>
                        </div>
                        {driver.laps != null && (
                          <GrandPrixSectors sectors={driver.laps[0].sectors} />
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default GrandPrixStages;
